import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';
import { kanbanStages } from '../data/mockData';
import { useCRM } from '../context/CRMContext';

const KanbanBoard = () => {
  const { policies, updatePolicyStage, policyTypes = [] } = useCRM();

  const onDragStart = (e, policyId) => {
    e.dataTransfer.setData('policyId', policyId);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = (e, targetStage) => {
    const policyId = e.dataTransfer.getData('policyId');
    updatePolicyStage(policyId, targetStage);
  };

  const getTypeColor = (type) => {
    return policyTypes.find(t => t.name === type)?.color || 'var(--primary)';
  };

  return (
    <div className="animate-fade-in" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>Embudos Acumulados</h1>
          <p className="text-muted">Arrastra y suelta pólizas entre las etapas.</p>
        </div>
      </div>

      <div className="kanban-board">
        {kanbanStages.map((stage) => {
          const stagePolicies = policies.filter(p => p.stage === stage.id);
          return (
            <div 
              key={stage.id} 
              className="kanban-column"
              onDragOver={onDragOver}
              onDrop={(e) => onDrop(e, stage.id)}
            >
              <div className="kanban-header">
                <span className="kanban-title">{stage.title}</span>
                <span className="kanban-count">{stagePolicies.length}</span>
              </div>
              
              <div className="kanban-cards">
                {stagePolicies.map(policy => (
                  <div 
                    key={policy.id} 
                    className="policy-card"
                    draggable
                    onDragStart={(e) => onDragStart(e, policy.id)}
                  >
                    <div className="policy-card-header">
                      <span className="policy-title">{policy.clientName}</span>
                      <span style={{ 
                        backgroundColor: `${getTypeColor(policy.type)}15`, 
                        color: getTypeColor(policy.type), 
                        border: `1px solid ${getTypeColor(policy.type)}30`,
                        padding: '0.2rem 0.5rem', 
                        borderRadius: '4px', 
                        fontSize: '0.7rem',
                        fontWeight: 600
                      }}>{policy.type}</span>
                    </div>
                    
                    <div className="policy-details">
                      <span>{policy.id}</span>
                      <span>{policy.phone}</span>
                    </div>

                    <div className="policy-footer">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span className="policy-value">{policy.value}</span>
                        {policy.value_uf && <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-muted)', marginTop: '0.1rem' }}>{policy.value_uf} UF</span>}
                      </div>
                      <div className="policy-actions">
                        <button className="action-btn email" title="Enviar Email"><Mail size={16} /></button>
                        <button className="action-btn whatsapp" title="Contactar por WhatsApp"><MessageCircle size={16} /></button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KanbanBoard;
